/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createInvoiceDtoFromDiscriminatorValue, serializeFailPaymentRequest, serializeInvoiceDto, type ErrorResponse, type FailPaymentRequest, type InternalErrorResponse, type InvoiceDto } from '../../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices/{invoiceId}/payments/{paymentId}/fail
 */
export interface FailRequestBuilder extends BaseRequestBuilder<FailRequestBuilder> {
    /**
     * Closes out a payment the processor declined. Only a pending payment can be failed — one already completed, failed or refunded is refused. The invoice's own status and balance do not move, because a pending payment was never counted toward them. Failed is the end of that payment's life: it cannot be completed later, so a retry means recording a new payment. Notes, when supplied, replace whatever the payment carried; send nothing and the existing notes are kept.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvoiceDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: FailPaymentRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvoiceDto | undefined>;
    /**
     * Closes out a payment the processor declined. Only a pending payment can be failed — one already completed, failed or refunded is refused. The invoice's own status and balance do not move, because a pending payment was never counted toward them. Failed is the end of that payment's life: it cannot be completed later, so a retry means recording a new payment. Notes, when supplied, replace whatever the payment carried; send nothing and the existing notes are kept.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: FailPaymentRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const FailRequestBuilderUriTemplate = "{+baseurl}/api/invoices/{invoiceId}/payments/{paymentId}/fail";
/**
 * Metadata for all the requests in the request builder.
 */
export const FailRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: FailRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createInvoiceDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeFailPaymentRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
